import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'

import Product from '../pages/Product'
import Checkout from '../pages/Checkout'
import CheckoutSuccess from "../pages/CheckoutSuccess";
import Cart from '../pages/Cart'
import PaymentFeedback from '../pages/PaymentFeedback'
import CookiePolicy from '../pages/CookiePolicy'
import Homepage from "@/pages/Homepage";

Vue.use(VueMeta);
Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        { path: '/', component: Homepage, name: 'Homepage' },
        { path: '/product/:alias', component: Product, name: 'Product' },
        { path: '/cart', component: Cart, name: 'Cart' },
        { path: '/checkout', component: Checkout, name: 'Checkout' },
        { path: '/checkout/success', component: CheckoutSuccess, name: 'Success' },
        { path: '/payment/feedback/:eshopId/', component: PaymentFeedback, name: 'PaymentFeedback'},
        { path: '/privacy', component: CookiePolicy},
    ],
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
})
